import axios from "axios";
import toast from "react-hot-toast";
import apiClient from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const headers = {
  "Accept-Language": "fa",
};

export const checkMobilePassword = (identifier: number) => {
  return axios
    .post(
      `${BASE_URL}/profile/check_has_password/`,
      { identifier },
      { headers }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const sendOtpHandler = (identifier: number | string) => {
  const requestBody = { identifier, allow_to_send_otp_debug: true };

  axios
    .post(`${BASE_URL}/profile/otp/`, requestBody)
    .then((response) => {
      if (response?.data?.message?.title === "Can not get new otp") {
        toast.error(
          `برای ارسال مجدد کد ${response?.data?.message?.ttl} ثانیه صبر کنید`
        );
      } else if (response?.data?.message?.title === "Max try to get otp") {
        toast.error("شما به حداکثر تعداد درخواست مجاز روزانه رسیده‌اید.");
      }
      return response;
    })
    .catch((err) => {});
};

export const loginWithMobile = (identifier: number | string, code: number) => {
  const requestBody = { identifier, code };

  return axios
    .post(`${BASE_URL}/profile/login/`, requestBody)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const registerDevice = (
  registration_id: number | string,
  type: string
) => {
  const requestBody = { registration_id, type };

  return apiClient
    .post(`${BASE_URL}/devices/`, requestBody)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};
